import React from "react";
import "./Leaderboard.scss";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";
import {
  Avatar,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from "@mui/material";
import { TopCustomer } from "types/Dashboard";
import MessageIcon from "@mui/icons-material/Message";
import Tooltip from "@mui/material/Tooltip";
type Props = {
  data: TopCustomer[];
};

const LeaderBoard: React.FC<Props> = (props) => {
  const { data } = props;

  // Sort data by stamp_count in descending order
  const sortedData = [...data].sort((a, b) => b.stamp_count - a.stamp_count);

  const rankLabels = ["1st", "2nd", "3rd"];
  const rankColors = [
    colors.primary.main,
    colors.success.main,
    colors.info.main
  ];

  return (
    <div className="leaderboard">
      <h1>Top Customers (Stamps Collection)</h1>
      <MDBox mt={5}>
        <List sx={{ width: "100%" }}>
          {sortedData.map((customer, index) => (
            <React.Fragment key={customer.id}>
              <ListItem
                secondaryAction={
                  index < 3 ? (
                    <IconButton
                      edge="end"
                      aria-label="rank"
                      sx={{
                        color: rankColors[index],
                        fontSize: 15,
                        fontWeight: "bold"
                      }}
                    >
                      {rankLabels[index]}
                    </IconButton>
                  ) : null
                }
              >
                <ListItemAvatar>
                  <Avatar>
                    {customer.user_name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={customer.user_name}
                  secondary={`${customer.stamp_count} stamps`}
                  primaryTypographyProps={{
                    fontSize: 14,
                    fontWeight: "medium",
                    letterSpacing: 0
                  }}
                  secondaryTypographyProps={{
                    fontSize: 12,
                    letterSpacing: 0
                  }}
                />
                <Tooltip title="Send Notification">
                  <IconButton>
                    <MessageIcon color="primary" />
                  </IconButton>
                </Tooltip>
              </ListItem>
              {index < sortedData.length - 1 && (
                <Divider sx={{ width: "100%" }} variant="fullWidth" />
              )}
            </React.Fragment>
          ))}
        </List>
      </MDBox>
    </div>
  );
};

export default LeaderBoard;
